module.exports = __webpack_public_path__ + "img/instapay.bc0566aa.svg";